import { cn } from "@theprelude/core";

export const RestartIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 14 14"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.358 12.0434C10.1483 13.0916 8.60066 13.6676 6.99998 13.6654C3.31798 13.6654 0.333313 10.6807 0.333313 6.9987C0.333313 3.3167 3.31798 0.332031 6.99998 0.332031C10.682 0.332031 13.6666 3.3167 13.6666 6.9987C13.6666 8.4227 13.22 9.7427 12.46 10.8254L10.3333 6.9987H12.3333C12.3332 5.7695 11.9085 4.57807 11.1311 3.62596C10.3537 2.67384 9.27122 2.01949 8.06687 1.7736C6.86252 1.52771 5.6102 1.70538 4.52176 2.27654C3.43333 2.84771 2.57559 3.77731 2.09366 4.90809C1.61173 6.03887 1.53518 7.3014 1.87697 8.48212C2.21876 9.66284 2.95791 10.6893 3.96937 11.3877C4.98083 12.0862 6.20251 12.4139 7.42774 12.3153C8.65298 12.2167 9.80655 11.6979 10.6933 10.8467L11.358 12.0434Z" />
  </svg>
);
